import React from "react";
import styled from "styled-components";
import media from "styled-media-query";
import InputAutoSuggest from "src/components/atoms/form/InputAutoSuggest";
import CheckBox from "src/components/atoms/form/CheckBox";
import RadioBox from "src/components/atoms/form/RadioBox";
import StyleConfig from "src/constants/StyleConfig";

interface Props {
  suggestions: string[];
  query: string;
  filterByStatus: string;
  filterByPickup: boolean;
  filterByReserved: boolean;
  onChangeQuery: (text: string) => void;
  onSuggestionsFetchRequested: (text: string) => void;
  onSuggestionsClearRequested: () => void;
  onSuggestionSelected: (text: string) => void;
  onChangeFilterByStatus: (value: string) => void;
  onChangeFilterByPickup: () => void;
  onChangeFilterByReserved: () => void;
}

const OrderFilterForm = ({ ...props }: Props) => {
  const {
    suggestions,
    query,
    filterByStatus,
    filterByPickup,
    filterByReserved,
    onChangeQuery,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    onSuggestionSelected,
    onChangeFilterByStatus,
    onChangeFilterByPickup,
    onChangeFilterByReserved,
  } = props;

  return (
    <Filter>
      <Search>
        <div className="search-input">
          <InputAutoSuggest
            suggestions={suggestions}
            inputType={"search"}
            inputValue={query}
            onChange={onChangeQuery}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            placeholder={"受取番号/注文者検索"}
          />
        </div>
      </Search>
      <Choises>
        <LabeledChoise>
          <Label>表示する商品を切り替える</Label>
          <RadioGroup>
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"準備する商品を表示"}
              isChecked={filterByStatus === "準備する商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"準備済の商品を表示"}
              isChecked={filterByStatus === "準備済の商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"受渡済の商品を表示"}
              isChecked={filterByStatus === "受渡済の商品を表示"}
              onChange={onChangeFilterByStatus}
            />
            <RadioBox
              id={"xxx"}
              name={"xxx"}
              value={"すべての商品を表示"}
              isChecked={filterByStatus === "すべての商品を表示"}
              onChange={onChangeFilterByStatus}
            />
          </RadioGroup>
        </LabeledChoise>
        <LabeledChoise>
          <Label>注文種別を絞り込む</Label>
          <CheckGroup>
            <CheckBox
              isDisabled={false}
              children={"取り置き商品"}
              isChecked={filterByPickup}
              onChange={onChangeFilterByPickup}
            />
            <CheckBox
              isDisabled={false}
              children={"予約注文"}
              isChecked={filterByReserved}
              onChange={onChangeFilterByReserved}
            />
          </CheckGroup>
        </LabeledChoise>
      </Choises>
    </Filter>
  );
};

const Filter = styled.div`
  display: block;

  .checkboxes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 20px 0 10px 0;

    ${media.greaterThan("medium")`
      justify-content: flex-end;
      width: auto;
      flex: 1;
      margin: 0;
    `};

    > * {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }
  }
`;

const Search = styled.div`
  width: 100%;
  display: flex;

  ${media.greaterThan("medium")`
    width: auto;
    flex: 1;
  `};

  .search-input {
    flex-grow: 2;

    input {
      border: none;
      border-radius: 4px;
    }
  }
`;

const Choises = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${media.greaterThan("medium")`
    justify-content: flex-start;
    > div {
      margin-right: 24px;
    }
  `};
`;

const LabeledChoise = styled.div`
  margin-top: 12px;
`;

const Label = styled.label`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
`;

const RadioGroup = styled.div`
  label {
    margin-top: 8px;
    input {
      width: 17px;
      height: 17px;
      border: 1px solid #cfcfd2;
    }
    input:after {
      width: 64%;
      height: 64%;
    }
    span {
      font-size: 12px;
    }
  }
`;

const CheckGroup = styled.div`
  label {
    margin-top: 8px;
    input {
      width: 16px;
      height: 16px;
    }
    span {
      font-size: 12px;
    }
  }
`;

export default OrderFilterForm;
